<template>
    <footer class="site-footer">
        <div class="site-footer__copy">
            <span>
                &copy; 2019 - {{ currentYear }} Ileana Sofronie
            </span>
           <span>All Rights Reserved  </span>
        </div>
    </footer>
</template>

<script>
    export default {
        computed: {
            currentYear() {
                return new Date().getFullYear();
            }
        },
    }
</script>

<style lang="scss" scoped>
    .site-footer {
        @extend %site-grid;
        padding: rem(25px 0);
        &__copy {
            grid-column: span 4;
            text-align: center;
            span {
                display: inline-block;
                font-size:rem(16px);
                font-weight: 400;
                line-height: rem(22px);
                margin:rem(5px 0);
            }
        }
        @include desktop () {
            padding: rem(50px 0 25px 0);
        }
    }
</style>